import React, { ElementType } from 'react';

import { Collapse, Grid, TableCell, TableCellBaseProps, TableRow, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ColumnDefinition, DataTableWithId } from 'components/Common/DataTable/DataTableTypes';

export const tableStyles = makeStyles(() => ({
  emptyTable: {
    borderBottom: 'none',
  },
  cell: {
    padding: 0,
  },
}));

type Props<T> = {
  rowId: string;
  labelId: string;
  headCells: ColumnDefinition<T>[];
  row: T;
  borders?: boolean;
  onRowClick?: (rowId: string) => void;
  selectedRowId?: string;
  renderExpanded?: React.ReactNode;
  url?: string;
};

export const DataTableRow = <T extends DataTableWithId>({
  rowId,
  labelId,
  row,
  headCells,
  borders = true,
  onRowClick = undefined,
  selectedRowId,
  renderExpanded,
}: Props<T>): React.ReactElement => {
  const classes = tableStyles();

  return (
    <>
      <TableRow
        hover
        tabIndex={-1}
        key={rowId}
        selected={selectedRowId === row.id}
        onClick={() => (onRowClick ? onRowClick(rowId) : null)}
      >
        {headCells.map((cell, index) => {
          const { id } = cell;
          const value = row[id] || '-';
          const render = cell.render;
          return (
            <TableCell
              key={id.toString()}
              component={'th' as unknown as ElementType<TableCellBaseProps>}
              id={`${labelId}-${index}`}
              scope="row"
              className={borders ? '' : classes.emptyTable}
            >
              {render ? (
                render(row)
              ) : value === '-' ? (
                <Typography>{value as string}</Typography>
              ) : (
                <Grid container direction="row" alignItems="flex-end">
                  <Grid item>
                    <Typography>{value as string}</Typography>
                  </Grid>
                </Grid>
              )}
            </TableCell>
          );
        })}
      </TableRow>
      {renderExpanded && (
        <TableRow>
          <TableCell style={{ padding: 0 }} colSpan={6}>
            <Collapse in={selectedRowId === row.id && !!renderExpanded}>{renderExpanded}</Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
};
